import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const CommercialPage = () => {
  const navigate = useNavigate();
  const services = [
    { icon: 'ri-building-2-line', title: 'Commercial HVAC', desc: 'Rooftop units, VRF systems, chillers, and split systems for office buildings, retail, warehouses, and more.' },
    { icon: 'ri-user-settings-line', title: 'Property Managers', desc: 'Dedicated account team, custom SLAs, priority dispatch, and monthly billing. One relationship for every property.' },
    { icon: 'ri-home-gear-line', title: 'Multi-Unit Residential', desc: 'Maintenance contracts for apartment complexes, condo buildings, and HOA communities.' },
    { icon: 'ri-building-line', title: 'Builders & Developers', desc: 'New construction HVAC, plumbing, and electrical for residential and commercial developers.' },
    { icon: 'ri-water-flash-line', title: 'Commercial Plumbing', desc: 'Full commercial plumbing services including grease trap, backflow prevention, and water heater systems.' },
    { icon: 'ri-flashlight-line', title: 'Commercial Electrical', desc: 'Panel upgrades, lighting retrofits, EV charger infrastructure, and emergency generator installation.' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="bg-[#0C2340] py-20 nav-offset">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Commercial Services</p>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-5">Built for Property Professionals</h1>
            <p className="text-xl text-white/75 mb-8">Commercial HVAC, plumbing, and electrical services for property managers, builders, and multi-unit operators. Custom contracts, dedicated teams.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button onClick={() => navigate('/contact')} className="bg-[#C41E3A] text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer">
                Contact Sales Team
              </button>
              <a href="tel:+18506698335" className="border border-white/30 text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-white/10 transition-colors flex items-center space-x-2 whitespace-nowrap">
                <i className="ri-phone-fill" />
                <span>(850) 669-8335</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4">Commercial Service Lines</h2>
            <p className="text-[#6B7280] max-w-2xl mx-auto">Full-scope commercial services managed by dedicated account teams with custom SLAs and transparent billing.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {services.map((s) => (
              <div key={s.title} className="p-7 bg-[#F8F9FB] rounded-xl border border-[#E2E8F0] hover:border-[#C41E3A]/30 transition-colors">
                <div className="w-12 h-12 bg-[#0C2340]/8 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-2xl text-[#0C2340]`} />
                </div>
                <h3 className="text-base font-bold text-[#111827] mb-2">{s.title}</h3>
                <p className="text-sm text-[#6B7280] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-[#0C2340] rounded-2xl p-10 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">Property Manager Program</h2>
              <p className="text-white/70 mb-6">One dedicated account manager, priority dispatch across all your properties, monthly billing, and custom SLAs designed around your portfolio size.</p>
              <ul className="space-y-2 mb-6">
                {['Dedicated account manager', 'Multi-property billing', 'Custom SLAs and response times', 'Priority emergency dispatch', 'Annual planning and budgeting support', 'Preferred pricing on all services'].map((f) => (
                  <li key={f} className="flex items-center space-x-2 text-sm text-white/80">
                    <i className="ri-check-line text-[#C41E3A]" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white/8 border border-white/10 rounded-xl p-8">
              <h3 className="text-white font-bold text-xl mb-4">Request a Commercial Proposal</h3>
              <p className="text-white/60 text-sm mb-6">Describe your portfolio and we&apos;ll create a custom maintenance and service contract.</p>
              <button onClick={() => navigate('/contact')} className="w-full bg-[#C41E3A] text-white py-3.5 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer">
                Request Proposal
              </button>
              <p className="text-white/40 text-xs text-center mt-3">Typical response within 1 business day</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CommercialPage;
